import styled from 'styled-components';

export const StyledWalletTransactionButtonWrapper = styled.div`
  display: flex;
  gap: 8px;
`;
